export function teamSlider() {
	let $teamSlider = $(".team-slider");
	let $teamInfoItem = $(".team-info .item");
	$teamSlider.slick({
    infinite: true,
    slidesToShow: 3,
		slidesToScroll: 1,
		speed: 499,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
          slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	$teamInfoItem.eq(0).addClass("active");
	$teamSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    let decl = currentSlide - nextSlide;
    if(decl === 1 || decl === (slick.slideCount-1)*(-1) ) {
      $teamSlider.addClass('is-prev');
    } else {
      $teamSlider.removeClass('is-prev');
    }
    setTimeout(()=>{
      $teamInfoItem.eq(currentSlide).removeClass("active");
      $teamInfoItem.eq(nextSlide).addClass("active");
		}, 500)
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/teamSlider.js